/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
import React, { useEffect, useRef, useState } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { FormattedMessage, useIntl } from 'react-intl';
import add from 'date-fns/add';
import sub from 'date-fns/sub';
import isSameDay from 'date-fns/isSameDay';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import {
  MdClose,
  MdEmail,
  MdOutlineArrowBack,
  MdOutlineCreate,
  MdOutlineFilterAlt,
  MdOutlineMail,
  MdOutlineSupportAgent,
  MdOutlineWhatsapp,
  MdPhone,
} from 'react-icons/md';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import { BsGraphUpArrow } from 'react-icons/bs';
import {
  searchFlightsApi,
  validateFlightPriceApi,
  validateInternationalFlightPriceApi,
  emailFlightOptions,
  getPassThroughInfo,
  getFareInclusion,
  getFareInclusionINTL,
} from '../../api/flightApi';
import OneWayResultCard from './OneWayResultCard';
import {
  formatDate,
  getGroupedFlightOptions,
  isBeforeDate,
  isSameDate,
  formatCurrency,
  isMobileWidth,
  hideUpdatesOptions,
  showUpdatesOptions,
  getNewDate,
  isEmpty,
  hideHeaderFooterInMobile,
  showHeaderFooterInMobile,
} from '../../shared/helper-utils/appUtils';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import AppModal from '../../shared/components/app-modal/AppModal';
import OneWayFilters from './OneWayFilters';
import {
  getObjectFromLS,
  getUserAgentId,
} from '../../shared/helper-utils/localStorage';
import {
  API_DATE_FORMAT,
  DATE_MONTH_DAY_FORMAT,
  NAVIGATION_ROUTES,
  TODAY_DATE,
  DATE_MONTH_YEAR_VIEW_FORMAT,
} from '../../shared/constants/Constants';
import NoSearchResults from './NoSearchResults';
import CountdownTimer from '../../shared/components/countdown-timer/CountdownTimer';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import RefineResults from './RefineResults';
import EmailContent from './EmailContent';
import { debounce } from '../../api/apiUtils';
import OneWayWhatsAppModal from './OneWayWhatsAppModal';
import { getUserDetails } from '../../api/profileApi';
import AppButton from '../../shared/components/app-button/AppButton';
import ModifySearch from '../flights/ModifySearch';
import AppPreviewLoader from '../../shared/components/app-preview-loader/AppPreviewLoader';
import SortOptions from './SortOptions';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';
import { useAppContext } from '../../saas/AppConfigWrapper';

const DOMESTIC_SEARCH_AIRLINES = [
  '6E',
  'SG',
  'AI',
  '9I',
  'S5',
  'IX',
  'QP',
  'S9',
  'IC',
];

const INTERNATIONAL_SEARCH_AIRLINES = ['All', 'GWS', '6E'];

const DOMESTIC_CORPORATE_SEARCH_AIRLINES = ['AI'];
const INTERNATIONAL_CORPORATE_SEARCH_AIRLINES = ['All'];
const SERIES_AIRLINES = ['All'];
const BRANDED_AIRLINES = ['AI'];

const DEFENCE_FARE_AIRLINES = ['6ED', 'SGD', 'QPD', 'I5D', 'IXD', 'AID'];

function FlightOneWaySearchResultsPage() {
  const { appConfig } = useAppContext();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const navigate = useNavigate();
  const FIFTEEN_MIN_IN_MILLI_SECS = 11 * 60 * 1000;
  const NOW_IN_MILLI_SECS = getNewDate(TODAY_DATE).getTime();
  const [fifteenMinFromNowInMilli, setFifteenMinFromNowInMilli] = useState(
    NOW_IN_MILLI_SECS + FIFTEEN_MIN_IN_MILLI_SECS,
  );
  // const isApiRequestProcessingRef = useRef(false);
  const bookingResponseRef = useRef(null);
  const [searchParams] = useSearchParams();
  const [alert, setAlert] = useState(undefined);
  const [hasSearchResults, setHasSearchResults] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [searchRequest, setSearchRequest] = useState(undefined);
  const [searchResults, setSearchResults] = useState([]);
  const allSearchResultsRef = useRef([]);
  const [isModifySearch, setIsModifySearch] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const [minFlightFare, setMinFlightFare] = useState(0);
  const [maxFlightFare, setMaxFlightFare] = useState(0);
  const [selectedFilters, setSelectedFilters] = useState({
    selectedMinPrice: minFlightFare,
    selectedMaxPrice: maxFlightFare,
    selectedStops: [],
    selectedDepartureTimes: [],
    selectedArraivalTimes: [],
    selectedCarriers: [],
    selectedFareTypes: [],
    selectedRefundStatus: [],
    selectedFlightNumber: '',
    selectedEquipment: '',
    isSameDayArraival: false,
  });
  // eslint-disable-next-line no-undef

  const [isAmPmFormatSelected, setIsAmPmFormatSelected] = useState(false);
  const selectedFareRef = useRef(undefined);
  const selectedFlightRef = useRef(undefined);
  // const [selectedFlight, setSelectedFlight] = useState(undefined);
  const [showPriceChangedModal, setShowPriceChangedModal] = useState(false);
  const [showRefineResult, setShowRefineResult] = useState(false);
  const [isInternationalSearch, setInternationalSearch] = useState(false);
  const [progressWidth, setProgressWidth] = useState(0);
  const showProgressRef = useRef(true);
  const flightCarriesRef = useRef([]);
  const flightFaresRef = useRef([]);
  const agentid = getUserAgentId();
  const [selectedForEmail, setSelectedForEmail] = useState([]);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [openWhatsappModal, setOpenWhatsappModal] = useState(false);
  const [showInvoiceFare, setShowInvoiceFare] = useState(false);
  const [abortController, setAbortController] = useState(new AbortController());
  const [page, setPage] = useState(0);
  const [shownResults, setShownResults] = useState([]);
  const sortOrderRef = useRef('asc');
  const sortParamRef = useRef('price');
  const [currencyOption, setCurrencyOption] = useState(appConfig?.appCurrency);
  const [conversionRate, setConversionRate] = useState(1);
  const [oldAmount, setOldAmount] = useState(0);
  const [newRepricedAmount, setnewRepricedAmount] = useState(0);
  const progressWidthCurrentRef = useRef(1);
  const passThroughResponseRef = useRef(null);
  const [dateDict, setDateDict] = useState([-3, -2, -1, 0, 1, 2, 3]);
  const [OpenAlerDialog, setOpenAlerDialog] = useState(false);
  const alertMessageRef = useRef('');
  const flightModifyRef = useRef(null);
  const [flightModifyDivHeight, setFlightModifyDivHeight] = useState(0);
  const fareInclusionRef = useRef([]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const entry of entries) {
        if (entry.target === flightModifyRef.current) {
          setFlightModifyDivHeight(entry.contentRect.height);
        }
      }
    });

    if (flightModifyRef.current) {
      resizeObserver.observe(flightModifyRef.current);
    }

    return () => {
      if (flightModifyRef.current) {
        resizeObserver.unobserve(flightModifyRef.current);
      }
    };
  }, [searchRequest]);

  useEffect(() => {
    hideHeaderFooterInMobile();
    return () => showHeaderFooterInMobile();
  }, []);

  // useEffect(() => {
  //   hideUpdatesOptions();
  //   return () => showUpdatesOptions();
  // });

  const appendResults = (pageNumber, results) => {
    const startindex = pageNumber * 20;
    const endIndex = startindex + 20;
    let newResults;
    if (startindex > results.length) {
      return;
    }
    if (endIndex > results.length) {
      newResults = results.slice(0, results.length);
    } else {
      newResults = results.slice(0, endIndex);
    }
    setShownResults(newResults);
  };

  useEffect(() => {
    appendResults(page, searchResults);
  }, [page]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollY } = window;
      const pageHeight =
        document.documentElement.scrollHeight - window.innerHeight - 100;
      // const scrollThreshold = 100;
      if (scrollY >= pageHeight) {
        setPage((prev) => prev + 1);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSort = (param, order, isOnward, results) => {
    sortOrderRef.current = order;
    sortParamRef.current = param;
    let list;
    if (results === undefined) {
      list = [...searchResults];
    } else {
      list = results;
    }
    if (param === 'price') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].flightfare[0].totalfq -
            flightOption1.recommendedflight[0].flightfare[0].totalfq,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].flightfare[0].totalfq -
            flightOption2.recommendedflight[0].flightfare[0].totalfq,
        );
      }
    } else if (param === 'duration') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].totaljourneyduration -
            flightOption1.recommendedflight[0].totaljourneyduration,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].totaljourneyduration -
            flightOption2.recommendedflight[0].totaljourneyduration,
        );
      }
    } else if (param === 'departure') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      }
    } else if (param === 'arrival') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[
                flightOption2.recommendedflight[0].flightlegs.length - 1
              ].arrtime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[
                flightOption1.recommendedflight[0].flightlegs.length - 1
              ].arrtime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[
                flightOption1.recommendedflight[0].flightlegs.length - 1
              ].arrtime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[
                flightOption2.recommendedflight[0].flightlegs.length - 1
              ].arrtime,
              10,
            ),
        );
      }
    } else if (param === 'airline') {
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) =>
          flightOption2.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption1.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      } else {
        list.sort((flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption2.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      }
    }
    setPage(0);
    appendResults(0, list);
    setSearchResults(list);
  };

  const handleSort1 = (param, order, isOnward, results) => {
    sortOrderRef.current = order;
    sortParamRef.current = param;
    let list;
    if (results === undefined) {
      list = [...searchResults];
    } else {
      list = results;
    }
    if (param === 'price') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].flightfare[0].totalfq -
            flightOption1.recommendedflight[0].flightfare[0].totalfq,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].flightfare[0].totalfq -
            flightOption2.recommendedflight[0].flightfare[0].totalfq,
        );
      }
    } else if (param === 'duration') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption2.recommendedflight[0].totaljourneyduration -
            flightOption1.recommendedflight[0].totaljourneyduration,
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].totaljourneyduration -
            flightOption2.recommendedflight[0].totaljourneyduration,
        );
      }
    } else if (param === 'departure') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      }
    } else if (param === 'arrival') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[
                flightOption2.recommendedflight[0].flightlegs.length - 1
              ].arrtime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[
                flightOption1.recommendedflight[0].flightlegs.length - 1
              ].arrtime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[
                flightOption1.recommendedflight[0].flightlegs.length - 1
              ].arrtime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[
                flightOption2.recommendedflight[0].flightlegs.length - 1
              ].arrtime,
              10,
            ),
        );
      }
    } else if (param === 'airline') {
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) =>
          flightOption2.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption1.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      } else {
        list.sort((flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption2.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      }
    }
    setPage(0);
    appendResults(0, list);
    return list;
  };

  const handleApplyFilter = debounce((filters) => {
    setOpenFilters(false);
    setSelectedFilters(filters);
    let filteredSearchResults = JSON.parse(
      JSON.stringify(allSearchResultsRef.current),
    );
    if (filters.selectedCarriers.length > 0) {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        let legs = resultRow.recommendedflight[0].flightlegs[0];
        legs = Array.isArray(legs) ? legs : [legs];
        return legs.some(
          (x) => filters.selectedCarriers.indexOf(x.validatingcarriername) > -1,
        );
      });
    }
    if (filters.selectedRefundStatus.length > 0) {
      filteredSearchResults.forEach((resultRow) => {
        let fares = resultRow.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const filteredFares = fares.filter(
          (x) => filters.selectedRefundStatus.indexOf(x.refundableinfo) > -1,
        );
        resultRow.recommendedflight[0].flightfare = filteredFares;
      });
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const fares = resultRow.recommendedflight[0].flightfare;
        return fares.length > 0;
      });
    }
    if (filters.selectedFareTypes.length > 0) {
      filteredSearchResults.forEach((resultRow) => {
        let fares = resultRow.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const filteredFares = fares.filter(
          (x) => filters.selectedFareTypes.indexOf(x.faretype) > -1,
        );
        resultRow.recommendedflight[0].flightfare = filteredFares;
      });
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const fares = resultRow.recommendedflight[0].flightfare;
        return fares.length > 0;
      });
    }
    if (filters.selectedStops.length > 0) {
      filteredSearchResults = filteredSearchResults.filter(
        (resultRow) =>
          filters.selectedStops.indexOf(
            resultRow.recommendedflight[0].numstops.toString(),
          ) > -1,
      );
    }
    if (filters.selectedDepartureTimes.length > 0) {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const depTime = Number(
          resultRow.recommendedflight[0].flightlegs[0].deptime,
        );
        return filters.selectedDepartureTimes.some((timeRange) => {
          const timeRangeArr = timeRange.split('-');
          return (
            depTime >= Number(timeRangeArr[0]) &&
            depTime <= Number(timeRangeArr[1])
          );
        });
      });
    }
    if (filters.selectedArraivalTimes.length > 0) {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const depTime = Number(
          resultRow.recommendedflight[0].flightlegs[
            resultRow.recommendedflight[0].flightlegs.length - 1
          ].arrtime,
        );
        return filters.selectedArraivalTimes.some((timeRange) => {
          const timeRangeArr = timeRange.split('-');
          return (
            depTime >= Number(timeRangeArr[0]) &&
            depTime <= Number(timeRangeArr[1])
          );
        });
      });
    }
    if (filters.selectedMinPrice) {
      filteredSearchResults = filteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightfare[0].totalfq >=
          filters.selectedMinPrice,
      );
    }
    if (filters.selectedMaxPrice) {
      filteredSearchResults = filteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightfare[0].totalfq <=
          filters.selectedMaxPrice,
      );
    }
    if (filters.selectedFlightNumber !== '') {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const carrier = filters.selectedFlightNumber
          .toLowerCase()
          .split('-')[0]
          .substring(0, 2);
        const fltNum = filters.selectedFlightNumber.split('-')[1];
        let legs = resultRow.recommendedflight[0].flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        if (fltNum) {
          return legs.some(
            (x) =>
              x.carrier.toLowerCase().indexOf(carrier) > -1 &&
              x.flightnumber.indexOf(fltNum) > -1,
          );
        }
        return legs.some((x) => x.carrier.toLowerCase().indexOf(carrier) > -1);
      });
    }
    if (filters.selectedEquipment !== '') {
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        let legs = resultRow.recommendedflight[0].flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        return legs.some(
          (x) =>
            x.equipment
              .toLowerCase()
              .indexOf(filters.selectedEquipment.toLowerCase()) > -1,
        );
      });
    }
    if (filters.isSameDayArraival === true) {
      filteredSearchResults = filteredSearchResults.filter(
        (resultRow) =>
          resultRow.recommendedflight[0].flightlegs[0].depdate ===
          resultRow.recommendedflight[0].flightlegs[
            resultRow.recommendedflight[0].flightlegs.length - 1
          ].arrdate,
      );
    }
    filteredSearchResults = handleSort1(
      sortParamRef.current,
      sortOrderRef.current,
      true,
      filteredSearchResults,
    );
    setSearchResults(filteredSearchResults);
  }, 300);

  const updateFlightsState = (response) => {
    if (
      response &&
      response.flightjourneys[0] !== '' &&
      response.flightjourneys[0] !== undefined &&
      response.flightjourneys[0].flightoptions.length !== 0
    ) {
      const flightOptions = Array.isArray(
        response.flightjourneys[0].flightoptions,
      )
        ? response.flightjourneys[0].flightoptions
        : [response.flightjourneys[0].flightoptions];
      flightOptions?.forEach((ele) => {
        let legs = ele?.recommendedflight[0]?.flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        const { validatingcarriername, validatingcarrier } = legs[0];
        if (!isEmpty(validatingcarriername) && !isEmpty(validatingcarrier)) {
          if (
            !flightCarriesRef.current.some(
              (x) => x.validatingcarriername === validatingcarriername,
            )
          ) {
            flightCarriesRef.current.push({
              validatingcarriername,
              validatingcarrier,
            });
          }
          flightCarriesRef.current.sort((option1, option2) =>
            option1.validatingcarriername.localeCompare(
              option2.validatingcarriername,
            ),
          );
        }
      });
      flightOptions?.forEach((ele) => {
        let fares = ele?.recommendedflight[0]?.flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const { faretype } = fares[0];
        if (!isEmpty(faretype)) {
          if (
            !flightFaresRef.current.some(
              (x) => x.toLowerCase() === faretype.toLowerCase(),
            )
          ) {
            flightFaresRef.current.push(faretype);
          }
          flightFaresRef.current.sort((option1, option2) =>
            option1.localeCompare(option2),
          );
        }
      });

      flightOptions.forEach((fo) => {
        let fares = fo.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        fares.forEach((fare) => {
          const carrierList = [];
          const seatsList = [];
          const bagList = [];
          const weighlist = [];
          const bookingClassList = [];
          const airFreeTextList = [];
          const equipmentList = [];
          const operatedByList = [];
          const handBagList = [];
          const handBagWeightList = [];
          fo.recommendedflight[0].flightlegs.forEach((leg) => {
            carrierList.push(leg.carrier);
            seatsList.push(leg.numseatsavailable);
            bagList.push(leg.bagweight);
            weighlist.push(leg.bagunit);
            handBagList.push(leg.cabinBagweight);
            handBagWeightList.push(leg.cabinBagunit);
            equipmentList.push(isEmpty(leg.equipment) ? '' : leg.equipment);
            operatedByList.push(isEmpty(leg.operatedby) ? '' : leg.operatedby);
            bookingClassList.push(leg.bookingclass);
            if (leg.weather_origin !== '') {
              airFreeTextList.push(leg.weather_origin);
            }
          });
          let supplierName = fo.recommendedflight[0].supplier;
          if (isEmpty(supplierName)) {
            const isAmadeus = fo.recommendedflight[0].nextracustomstr
              .split(',')
              .some((word) => word.includes('AMADEUS'));
            if (isAmadeus) {
              supplierName = 'amadeus';
            }
          }
          fare.supplierName = supplierName;
          fare.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
          fare.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
          fare.ismorefaresavailable =
            fo.recommendedflight[0].ismorefaresavailable;
          fare.isminifarerulesrequired =
            fo.recommendedflight[0].isminifarerulesrequired;
          fare.flightCarrier = carrierList;
          fare.cabinBagweight = handBagList;
          fare.cabinBagunit = handBagWeightList;
          fare.flightEquipment = equipmentList;
          fare.flightOperatedBy = operatedByList;
          fare.numseatsavailable = seatsList;
          fare.flightBagWeight = bagList;
          fare.flightBagUnit = weighlist;
          fare.bookingClass = bookingClassList;
          fare.airFreeText = airFreeTextList;
        });
      });
      const allFlights = [...flightOptions, ...allSearchResultsRef.current];

      let groupedFlightOptions = getGroupedFlightOptions(allFlights);
      groupedFlightOptions = Object.values(groupedFlightOptions);
      const updatedGroupedOptions = [...groupedFlightOptions];
      updatedGroupedOptions.sort(
        (flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightfare[0].totalfq -
          flightOption2.recommendedflight[0].flightfare[0].totalfq,
      );
      let minFare = minFlightFare;
      let maxFare = maxFlightFare;
      const totalFares = [];
      updatedGroupedOptions.forEach((option) => {
        const fares = option.recommendedflight[0].flightfare;
        totalFares.push(...fares);
      });
      totalFares.sort(
        (flightOption1, flightOption2) =>
          flightOption1.totalfq - flightOption2.totalfq,
      );
      minFare = totalFares[0].totalfq;
      maxFare = totalFares[totalFares.length - 1].totalfq;
      allSearchResultsRef.current = JSON.parse(
        JSON.stringify(updatedGroupedOptions),
      );
      setSearchResults(updatedGroupedOptions);
      setMinFlightFare(minFare);
      setMaxFlightFare(maxFare);
      setHasSearchResults(true);
    }
  };
  const sendParallelRequests = (mergedSearchObj, controller) => {
    if (mergedSearchObj.searchtype === 'normal') {
      try {
        let current = 1;
        let normalAirlines = [];
        let corporateAirlines = [];
        let brandedAirlines = [];
        let seriesAirlines = [];
        let prefCarrierExtraCall = [];
        let isIntl = false;
        if (
          mergedSearchObj.originLocation
            .split(',')
            .pop()
            .trim()
            .toLowerCase() !== 'india' ||
          mergedSearchObj.destinationLocation
            .split(',')
            .pop()
            .trim()
            .toLowerCase() !== 'india'
        ) {
          isIntl = true;
        }
        if (mergedSearchObj.prefcarrier === 'All') {
          if (isIntl) {
            normalAirlines = [...INTERNATIONAL_SEARCH_AIRLINES];
            corporateAirlines = [...INTERNATIONAL_CORPORATE_SEARCH_AIRLINES];
            brandedAirlines = ['All'];
          } else {
            normalAirlines = [...DOMESTIC_SEARCH_AIRLINES];
            corporateAirlines = [...DOMESTIC_CORPORATE_SEARCH_AIRLINES];
            brandedAirlines = [...BRANDED_AIRLINES];
            seriesAirlines = [...SERIES_AIRLINES];
          }
        } else {
          normalAirlines = [mergedSearchObj.prefcarrier];
          if (isIntl) {
            prefCarrierExtraCall = ['GWS'];
          } else if (mergedSearchObj.prefcarrier !== '6E') {
            prefCarrierExtraCall = ['6E'];
          }
        }
        const airlineLength =
          normalAirlines.length +
          corporateAirlines.length +
          brandedAirlines.length +
          seriesAirlines.length +
          prefCarrierExtraCall.length;
        normalAirlines.forEach(async (airline) => {
          mergedSearchObj.prefcarrier = airline;
          mergedSearchObj.searchtype = 'normal';
          try {
            const response = await searchFlightsApi(
              mergedSearchObj,
              controller,
            );
            if (response.domint === 'international') {
              setInternationalSearch(true);
            }
            if (current === airlineLength) {
              showProgressRef.current = false;
            }
            setProgressWidth((current * 100) / airlineLength);
            current += 1;
            updateFlightsState(response);
          } catch (error) {
            // console.error(error);
          }
        });
        if (corporateAirlines.length > 0) {
          corporateAirlines.forEach(async (airline) => {
            mergedSearchObj.prefcarrier = airline;
            mergedSearchObj.searchtype = 'corporateonly';
            try {
              const response = await searchFlightsApi(
                mergedSearchObj,
                controller,
              );
              if (response.domint === 'international') {
                setInternationalSearch(true);
              }
              if (current === airlineLength) {
                showProgressRef.current = false;
              }
              setProgressWidth((current * 100) / airlineLength);
              current += 1;
              updateFlightsState(response);
            } catch (error) {
              // console.error(error);
            }
          });
        }
        if (brandedAirlines.length > 0) {
          brandedAirlines.forEach(async (airline) => {
            mergedSearchObj.prefcarrier = airline;
            mergedSearchObj.searchtype = 'branded';
            try {
              const response = await searchFlightsApi(
                mergedSearchObj,
                controller,
              );
              if (response.domint === 'international') {
                setInternationalSearch(true);
              }
              if (current === airlineLength) {
                showProgressRef.current = false;
              }
              setProgressWidth((current * 100) / airlineLength);
              current += 1;
              updateFlightsState(response);
            } catch (error) {
              // console.error(error);
            }
          });
        }
        if (seriesAirlines.length > 0) {
          seriesAirlines.forEach(async (airline) => {
            mergedSearchObj.prefcarrier = airline;
            mergedSearchObj.searchtype = 'seriesfares';
            try {
              const response = await searchFlightsApi(
                mergedSearchObj,
                controller,
              );
              if (response.domint === 'international') {
                setInternationalSearch(true);
              }
              if (current === airlineLength) {
                showProgressRef.current = false;
              }
              setProgressWidth((current * 100) / airlineLength);
              current += 1;
              updateFlightsState(response);
            } catch (error) {
              // console.error(error);
            }
          });
        }
        if (prefCarrierExtraCall.length > 0) {
          prefCarrierExtraCall.forEach(async (airline) => {
            mergedSearchObj.prefcarrier = airline;
            mergedSearchObj.searchtype = 'normal';
            try {
              const response = await searchFlightsApi(
                mergedSearchObj,
                controller,
              );
              if (response && response.domint === 'international') {
                setInternationalSearch(true);
              }
              if (current === airlineLength) {
                showProgressRef.current = false;
              }
              setProgressWidth((current * 100) / airlineLength);
              current += 1;
              updateFlightsState(response);
            } catch (error) {
              // console.error(error);
            }
          });
        }
      } catch (error) {
        // console.error('user aborted the request');
        return undefined;
      }
    } else if (mergedSearchObj.searchtype === 'seriesfares') {
      let seriesAirlines = [];
      let current = 1;
      seriesAirlines = [...SERIES_AIRLINES];
      seriesAirlines.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'seriesfares';
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (response.domint === 'international') {
            setInternationalSearch(true);
          }
          if (current === seriesAirlines.length) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / seriesAirlines.length);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    } else if (mergedSearchObj.searchtype === 'defenceonly') {
      let current = 1;
      const normalAirlines = [...DEFENCE_FARE_AIRLINES];
      const airlinesLength = normalAirlines.length;
      normalAirlines.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'defenceonly';
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (response.domint === 'international') {
            setInternationalSearch(true);
          }
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    } else {
      let current = 1;
      let SPECIAL_AIRLINES = ['6E', 'SG', 'UK', 'I5', 'QP'];
      let isIntl = false;
      if (
        mergedSearchObj.originLocation.split(',').pop().trim().toLowerCase() !==
          'india' ||
        mergedSearchObj.destinationLocation
          .split(',')
          .pop()
          .trim()
          .toLowerCase() !== 'india'
      ) {
        isIntl = true;
      }
      if (isIntl) {
        SPECIAL_AIRLINES = ['GWS'];
      }
      let normalAirlines = [];
      let prefCarrierExtraCall = [];
      if (mergedSearchObj.prefcarrier !== 'All') {
        const hasPrefCarrier =
          SPECIAL_AIRLINES.indexOf(mergedSearchObj.prefcarrier) > -1;
        if (hasPrefCarrier) {
          normalAirlines = [mergedSearchObj.prefcarrier];
        } else {
          normalAirlines = [...SPECIAL_AIRLINES];
          setAlert({
            title: formattedMessage('flight_search_title'),
            variant: 'error',
            description: `${formattedMessage(
              'showing_results_of',
            )} 6E, SG, UK, I5, QP ${formattedMessage('with')} ${
              mergedSearchObj.searchtype
            } ${formattedMessage('fare_instead')} ${
              mergedSearchObj.prefcarrier
            }`,
          });
        }
      } else {
        normalAirlines = [...SPECIAL_AIRLINES];
        if (
          mergedSearchObj.prefcarrier !== '6E' &&
          mergedSearchObj.prefcarrier !== 'All'
        ) {
          prefCarrierExtraCall = ['6E'];
        }
      }
      const airlinesLength =
        prefCarrierExtraCall.length + normalAirlines.length;
      normalAirlines.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (response.domint === 'international') {
            setInternationalSearch(true);
          }
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
      prefCarrierExtraCall.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (response.domint === 'international') {
            setInternationalSearch(true);
          }
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    }
  };

  const getFlightSearchResults = async (mergedSearchObj, controller) => {
    if (
      mergedSearchObj.searchtype === 'seniorcitizen' ||
      mergedSearchObj.searchtype === 'student'
    ) {
      if (
        parseInt(mergedSearchObj.numinfants, 10) > 0 ||
        parseInt(mergedSearchObj.numchildren, 10) > 0
      ) {
        setAlert({
          title: 'Flight Search',
          description: 'Children and Infants are not allowed for this booking',
          variant: 'error',
        });
        return false;
      }
    }
    sendParallelRequests(mergedSearchObj, controller);
    const dateDiff = differenceInCalendarDays(
      getNewDate(mergedSearchObj.onwarddate),
      getNewDate(TODAY_DATE),
    );
    if (dateDiff === 0) {
      setDateDict([0, 1, 2, 3, 4, 5, 6]);
    } else if (dateDiff === 1) {
      setDateDict([-1, 0, 1, 2, 3, 4, 5]);
    } else if (dateDiff === 2) {
      setDateDict([-2, -1, 0, 1, 2, 3, 4]);
    } else {
      setDateDict([-3, -2, -1, 0, 1, 2, 3]);
    }
  };
  const resetSearchResults = () => {
    selectedFareRef.current = undefined;
    selectedFlightRef.current = undefined;
    setSelectedFilters({
      selectedMinPrice: 0,
      selectedMaxPrice: 0,
      selectedStops: [],
      selectedDepartureTimes: [],
      selectedArraivalTimes: [],
      selectedCarriers: [],
      selectedFareTypes: [],
      selectedRefundStatus: [],
      selectedFlightNumber: '',
      selectedEquipment: '',
      isSameDayArraival: false,
    });
    setInternationalSearch(false);
    setMinFlightFare(0);
    setMaxFlightFare(0);
    setSearchResults([]);
    setProgressWidth(0);
    setHasSearchResults(undefined);
    setIsModifySearch(false);
    allSearchResultsRef.current = [];
    flightCarriesRef.current = [];
    flightFaresRef.current = [];
    showProgressRef.current = true;
    setSelectedForEmail([]);
    setPage(0);
    progressWidthCurrentRef.current = 1;
    passThroughResponseRef.current = null;
    setDateDict([-3, -2, -1, 0, 1, 2, 3]);
    setFifteenMinFromNowInMilli(
      getNewDate(TODAY_DATE).getTime() + FIFTEEN_MIN_IN_MILLI_SECS,
    );
  };

  useEffect(() => {
    setAbortController(new AbortController());
    if (searchParams) {
      const currentParams = Object.fromEntries([...searchParams]);
      setSearchRequest(currentParams);
      const searchObj = {
        origin: '',
        destination: '',
        onwarddate: getNewDate(TODAY_DATE),
        returndate: '',
        numadults: '1',
        numchildren: '0',
        numinfants: '0',
        journeytype: 'OneWay',
        prefclass: 'Y',
        requestformat: 'JSON',
        resultformat: 'JSON',
        searchtype: 'normal',
        sortkey: '',
        issbt: 'false',
        profileid: '',
        numresults: 100,
        actionname: 'FLIGHTSEARCH',
        preddeptimewindow: null,
        prefarrtimewindow: null,
        prefcarrier: '',
        prefcarrierall: '',
        excludecarriers: '',
        refundtype: 'All',
        layovertime: '',
        promocode: '',
        nonstopsearch: 'false',
      };
      const mergedSearchObj = { ...searchObj, ...currentParams };
      resetSearchResults();
      if (mergedSearchObj.nonstopsearch === 'true') {
        setSelectedFilters((prev) => ({
          ...prev,
          selectedStops: ['0'],
        }));
      }
      const controller = abortController;
      const { signal } = controller;
      getFlightSearchResults(mergedSearchObj, signal);
    }
    return () => {
      if (abortController) {
        abortController.abort(); // Clean up controller on component unmount or query change
      }
    };
  }, [searchParams]);

  useEffect(() => {
    if (allSearchResultsRef.current.length > 0) {
      handleApplyFilter(selectedFilters);
    }
  }, [allSearchResultsRef.current]);

  const handleFlightSelectionForEmail = (flight, fare) => {
    setSelectedForEmail((prevItems) => {
      if (
        prevItems.some(
          (selectedItem) =>
            selectedItem.fare.nextraflightkey === fare.nextraflightkey,
        )
      ) {
        return prevItems.filter(
          (selectedItem) =>
            selectedItem.fare.nextraflightkey !== fare.nextraflightkey,
        );
      }
      return [...prevItems, { flight, fare }];
    });
  };

  const handleOpenEmailModal = () => {
    if (selectedForEmail.length > 0) {
      setOpenEmailModal(true);
    } else {
      setAlert({
        title: 'Email',
        description: 'Select atleast one fare',
        variant: 'error',
      });
    }
  };

  const handleopenWhatsappModal = () => {
    if (selectedForEmail.length > 0) {
      setOpenWhatsappModal(true);
    } else {
      setAlert({
        title: 'WhatsApp',
        description: 'Select atleast one fare',
        variant: 'error',
      });
    }
  };

  const handleSendWhatsappMessage = (whatsappNumber, msg) => {
    setIsLoading(true);
    const encodedMessage = encodeURIComponent(msg);
    const whatsAppUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsAppUrl, '_blank');
    setOpenWhatsappModal(false);
    setSelectedForEmail([]);
    setIsLoading(false);
  };
  const handleSendEmailMessage = async (senderEmail, emailContent) => {
    setIsLoading(true);
    let fromEmail = '';
    let fromName = '';
    const res = await getUserDetails(agentid);
    if (res.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      fromEmail = User.ContactEmail;
      fromName = `${User.FirstName} ${User.LastName}`;
    }
    if (fromEmail !== '') {
      const emailSubject = `Your flight booking details for ${
        searchRequest.originLocation.split(',')[0]
      } - 
      ${searchRequest.destinationLocation.split(',')[0]} ${formatDate(
        getNewDate(searchRequest.onwarddate),
        API_DATE_FORMAT,
      )}`;
      const response = await emailFlightOptions(
        fromEmail,
        fromName,
        senderEmail,
        emailContent,
        emailSubject,
      );
      if (response && response.Root?.Status === 'OK') {
        setAlert({
          title: 'Email',
          description: 'Email Sent Successfully',
          variant: 'success',
        });
        setOpenEmailModal(false);
        setIsLoading(false);
      } else {
        setAlert({
          title: 'Email',
          description: response.Root?.Message
            ? response.Root?.Message
            : 'Failed to send email',
          variant: 'error ',
        });
        setOpenEmailModal(false);
        setIsLoading(false);
      }
    } else {
      setAlert({
        title: 'User Details',
        description: res.ApiStatus?.Message
          ? res.ApiStatus?.Message
          : 'Failed to load Agent Details',
        variant: 'error ',
      });
      setOpenEmailModal(false);
      setIsLoading(false);
    }
    setSelectedForEmail([]);
  };

  const navigateToBookingPage = (rePriceResponse) => {
    const flight = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0],
    };
    const fare = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0]
          .flightfare,
    };
    const fareKeys = {
      onward: selectedFareRef.current.nextraflightkey,
    };
    navigate(NAVIGATION_ROUTES.FLIGHT.FLIGHT_BOOK_ROUTE, {
      state: {
        searchRequest,
        rePriceResponse,
        selectedFlight: flight,
        selectedFare: fare,
        passThroughInfo: passThroughResponseRef.current,
        selectedFareKeys: fareKeys,
        journeyType: 'oneway',
        domInt: isInternationalSearch ? 'international' : 'domestic',
      },
    });
  };

  const handleDirectNavigateToBookingPage = async (key, rePriceResponse) => {
    setIsLoading(true);
    const domint = isInternationalSearch ? 'international' : 'domestic';
    const res = await getPassThroughInfo(domint, rePriceResponse.bookingkey);
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      const { PassthroughBookingObject } = res.ApiStatus.Result;
      if (PassthroughBookingObject) {
        passThroughResponseRef.current = PassthroughBookingObject;
      }
    }
    const flight = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0],
    };
    const fare = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0]
          .flightfare,
    };
    const fareKeys = {
      onward: key,
    };
    navigate(NAVIGATION_ROUTES.FLIGHT.FLIGHT_BOOK_ROUTE, {
      state: {
        searchRequest,
        rePriceResponse,
        selectedFlight: flight,
        selectedFare: fare,
        selectedFareKeys: fareKeys,
        passThroughInfo: passThroughResponseRef.current,
        journeyType: 'oneway',
        domInt: isInternationalSearch ? 'international' : 'domestic',
      },
    });
  };
  const continueBooking = async () => {
    setOpenAlerDialog(false);
    try {
      setIsLoading(true);
      const userProifle = getObjectFromLS(APP_USER_PROFILE);
      let response;
      if (isInternationalSearch) {
        response = await validateInternationalFlightPriceApi(
          userProifle.agentId,
          'oneway',
          selectedFareRef.current.nextraflightkey,
        );
      } else {
        response = await validateFlightPriceApi(
          userProifle.agentId,
          searchRequest.journeytype,
          selectedFareRef.current.nextraflightkey,
        );
      }
      setIsLoading(false);
      if (
        response &&
        response.NextraPricingResponseV4 &&
        response.NextraPricingResponseV4.statuscode === '200'
      ) {
        const domint = isInternationalSearch ? 'international' : 'domestic';
        const res = await getPassThroughInfo(
          domint,
          response.NextraPricingResponseV4.bookingkey,
        );
        if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
          const { PassthroughBookingObject } = res.ApiStatus.Result;
          if (PassthroughBookingObject) {
            passThroughResponseRef.current = PassthroughBookingObject;
          }
        }
        if (response.NextraPricingResponseV4.pricechanged) {
          bookingResponseRef.current = response.NextraPricingResponseV4;
          setnewRepricedAmount(response.NextraPricingResponseV4.newamount);
          setOldAmount(response.NextraPricingResponseV4.oldamount);
          setShowPriceChangedModal(true);
        } else {
          navigateToBookingPage(response.NextraPricingResponseV4);
        }
      } else if (
        response &&
        response.ApiStatus &&
        response.ApiStatus.Status !== 'NOK'
      ) {
        setAlert({
          title: formattedMessage('booking_error'),
          description: response.ApiStatus.Message,
          variant: 'error',
        });
      } else {
        setAlert({
          title: formattedMessage('booking_error'),
          description: response.ApiStatus?.Message,
          variant: 'error',
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleBook = async () => {
    try {
      const searchRequestOrigin = searchRequest.origin;
      const searchRequestDestination = searchRequest.destination;
      const selectedFlightOrigin =
        selectedFlightRef.current.flightlegs[0].origin;
      const selectedFlightDestination =
        selectedFlightRef.current.flightlegs[
          selectedFlightRef.current.flightlegs.length - 1
        ].destination;
      if (
        searchRequestOrigin !== selectedFlightOrigin ||
        searchRequestDestination !== selectedFlightDestination
      ) {
        alertMessageRef.current = `You Searched flights from ${searchRequestOrigin} to ${searchRequestDestination} but booking from ${selectedFlightOrigin} to ${selectedFlightDestination}. Do you want to continue with it?`;
        setOpenAlerDialog(true);
      } else {
        continueBooking();
      }
    } catch (error) {
      //
    }
  };

  const handleFareSelection = (flight, fare) => {
    selectedFareRef.current = fare;
    selectedFlightRef.current = flight;
    handleBook();
  };

  const handlePriceChangedModalClose = (isContinue) => {
    if (isContinue) {
      navigateToBookingPage(bookingResponseRef.current);
    }
    setShowPriceChangedModal(false);
  };

  const handlePrevDay = async () => {
    if (searchRequest && searchRequest.onwarddate) {
      const request = { ...searchRequest };
      const todayDate = getNewDate(TODAY_DATE);
      const date = sub(getNewDate(searchRequest.onwarddate), { days: 1 });
      if (isBeforeDate(todayDate, date) || isSameDate(todayDate, date)) {
        request.onwarddate = formatDate(getNewDate(date), API_DATE_FORMAT);
        resetSearchResults();
        let queryParam = `origin=${searchRequest.origin}&originLocation=${searchRequest.originLocation}&destination=${searchRequest.destination}&destinationLocation=${searchRequest.destinationLocation}&onwarddate=${request.onwarddate}`;
        queryParam += `&numadults=${searchRequest.numadults}&numchildren=${searchRequest.numchildren}&numinfants=${searchRequest.numinfants}&prefclass=${searchRequest.prefclass}&journeytype=${searchRequest.journeytype}&preddeptimewindow=&searchtype=${searchRequest.searchtype}&promocode=${searchRequest.promocode}`;
        navigate(
          `${NAVIGATION_ROUTES.FLIGHT.ONE_WAY_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
        );
      } else {
        setAlert({
          variant: 'error',
          title: formattedMessage('flight_search_title'),
          description: formattedMessage('prev_day_alert'),
        });
      }
    }
  };

  const handleNextDay = async () => {
    try {
      if (searchRequest && searchRequest.onwarddate) {
        // abortFetching();
        const request = { ...searchRequest };
        const date = add(getNewDate(searchRequest.onwarddate), { days: 1 });
        request.onwarddate = formatDate(getNewDate(date), API_DATE_FORMAT);
        if (
          request.returndate === '' ||
          request.returndate === undefined ||
          request.returndate == null
        ) {
          request.returndate = '';
        }
        resetSearchResults();
        let queryParam = `origin=${searchRequest.origin}&originLocation=${searchRequest.originLocation}&destination=${searchRequest.destination}&destinationLocation=${searchRequest.destinationLocation}&onwarddate=${request.onwarddate}`;
        if (request.returndate !== '') {
          queryParam += `&returndate=${searchRequest.returndate}`;
        }
        queryParam += `&numadults=${searchRequest.numadults}&numchildren=${searchRequest.numchildren}&numinfants=${searchRequest.numinfants}&prefclass=${searchRequest.prefclass}&journeytype=${searchRequest.journeytype}&preddeptimewindow=&searchtype=${searchRequest.searchtype}&promocode=${searchRequest.promocode}`;
        navigate(
          `${NAVIGATION_ROUTES.FLIGHT.ONE_WAY_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
        );
      }
    } catch (error) {
      // console.error('User aborted the request');
      return undefined;
    }
  };

  const handleTimeFormatChange = (isAmPmFormat) => {
    setIsAmPmFormatSelected(isAmPmFormat);
  };

  const handleSearchByDate = (date) => {
    try {
      if (searchRequest && searchRequest.onwarddate) {
        const request = { ...searchRequest };
        request.onwarddate = formatDate(getNewDate(date), API_DATE_FORMAT);
        resetSearchResults();
        let queryParam = `origin=${request.origin}&originLocation=${request.originLocation}&destination=${request.destination}&destinationLocation=${request.destinationLocation}&onwarddate=${request.onwarddate}`;
        queryParam += `&numadults=${request.numadults}&numchildren=${request.numchildren}&numinfants=${request.numinfants}&prefclass=${request.prefclass}&prefcarrier=${searchRequest.prefcarrier}&journeytype=${request.journeytype}&preddeptimewindow=&searchtype=${request.searchtype}&promocode=${request.promocode}`;
        navigate(
          `${NAVIGATION_ROUTES.FLIGHT.ONE_WAY_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
        );
      }
    } catch (error) {
      // console.error('User aborted the request');
      return undefined;
    }
  };
  const dominn = isInternationalSearch ? 'international' : 'domestic';
  const isSelectedDate = (index) => {
    const date = add(getNewDate(searchRequest.onwarddate), {
      days: index,
    });
    return isSameDay(getNewDate(searchRequest.onwarddate), date);
  };
  const handleFareInclusion = async (domInt) => {
    const response = await getFareInclusion(domInt);
    if (
      response &&
      response.Root &&
      response.Root.Status === 'OK' &&
      response.Root.StatusCode === 200
    ) {
      const fareInclusionsMap = {};
      let fareInclusions = response.Root.Result.FareInclusions.FareInclusion;
      fareInclusions = Array.isArray(fareInclusions)
        ? fareInclusions
        : [fareInclusions];
      fareInclusions.forEach((incl, index) => {
        if (fareInclusionsMap[incl.FareType]) {
          fareInclusionsMap[incl.FareType] = incl;
        } else {
          fareInclusionsMap[incl.FareType] = incl;
        }
      });
      fareInclusionRef.current = fareInclusionsMap;
    }
  };
  const handleFareInclusionIntl = async () => {
    const response = await getFareInclusionINTL();
    if (
      response &&
      response.Root &&
      response.Root.Status === 'OK' &&
      response.Root.StatusCode === 200
    ) {
      const fareInclusionsMap = {};
      let fareInclusions = response.Root.Result.FareInclusions.FareInclusion;
      fareInclusions = Array.isArray(fareInclusions)
        ? fareInclusions
        : [fareInclusions];
      fareInclusions.forEach((incl, index) => {
        if (fareInclusionsMap[incl.FareType]) {
          fareInclusionsMap[incl.FareType] = incl;
        } else {
          fareInclusionsMap[incl.FareType] = incl;
        }
      });
      fareInclusionRef.current = fareInclusionsMap;
    }
  };
  useEffect(() => {
    if (isInternationalSearch) {
      handleFareInclusionIntl();
    } else {
      handleFareInclusion();
    }
  }, [isInternationalSearch]);

  const handleUpdateMoreFares = (brandedFares, key) => {
    allSearchResultsRef.current.forEach((flight) => {
      if (flight.recommendedflight[0].nextraflightkey === key) {
        const totalFares = [
          ...flight.recommendedflight[0].flightfare,
          ...brandedFares,
        ];
        totalFares.sort((fare1, fare2) => fare1.totalfq - fare2.totalfq);
        flight.recommendedflight[0].flightfare = [...totalFares];
        flight.recommendedflight[0].moreFaresCallDOne = true;
      }
    });
  };

  return (
    <section className="flight-one-way-search-results-page">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {showProgressRef.current && (
        <div className="flight-progress-container">
          <ProgressBar striped variant="info" now={progressWidth} />
        </div>
      )}
      <div className="countdown-timer-container visually-hidden">
        <CountdownTimer
          targetDate={fifteenMinFromNowInMilli}
          continueBtnText={formattedMessage('continue_btn')}
          continueRoutePath={formattedMessage('refresh_btn')}
        />
      </div>
      {searchRequest && (
        <>
          <div
            className="modify-search-container hide-for-599px"
            ref={flightModifyRef}
          >
            <ModifySearch
              isModifySearch={isModifySearch}
              previousSearchRequest={searchRequest}
            />
          </div>
          <div className="modify-search-container show-for-599px">
            <div className="d-flex">
              <AppIconButton
                onClick={() => navigate(-1)}
                className="white-color"
                variant="transparent"
              >
                <MdOutlineArrowBack />
              </AppIconButton>
              <div className="d-flex justify-content-between p-2 align-items-center flex-1">
                <div className="fs-14 white-color">
                  <div>
                    {searchRequest.originLocation.split(',')[0]} to{' '}
                    {searchRequest.destinationLocation.split(',')[0]}
                  </div>
                  <div className="fs-10">
                    <span>{searchRequest.journeytype} | </span>
                    {formatDate(
                      getNewDate(searchRequest.onwarddate),
                      DATE_MONTH_YEAR_VIEW_FORMAT,
                    )}
                  </div>
                </div>
                <div className="d-flex  align-items-center">
                  {isModifySearch ? (
                    <AppIconButton
                      className="white-color"
                      variant="transparent"
                      onClick={() => setIsModifySearch(false)}
                    >
                      <MdClose className="fs-4" />
                    </AppIconButton>
                  ) : (
                    <AppIconButton
                      className="white-color"
                      variant="transparent"
                      onClick={() => setIsModifySearch(true)}
                    >
                      <MdOutlineCreate className="fs-4" />
                    </AppIconButton>
                  )}
                  <AppIconButton
                    variant="transparent"
                    className="fs-14 white-color"
                    onClick={() => setShowInvoiceFare((prev) => !prev)}
                  >
                    {showInvoiceFare ? (
                      <IoMdEyeOff title="Net Fare" />
                    ) : (
                      <IoMdEye title="Net Fare" />
                    )}
                  </AppIconButton>
                  <AppIconButton
                    className="white-color"
                    variant="transparent"
                    onClick={() => setOpenFilters(true)}
                  >
                    <MdOutlineFilterAlt className="fs-4" />
                  </AppIconButton>
                </div>
              </div>
            </div>
            <div
              className={`slide-container ${
                isModifySearch ? 'slide-container_open' : ''
              }`}
              aria-hidden={!isModifySearch}
            >
              <ModifySearch
                isModifySearch={isModifySearch}
                previousSearchRequest={searchRequest}
              />
            </div>
          </div>
          {progressWidth < 100 && allSearchResultsRef.current.length === 0 && (
            <AppPreviewLoader />
          )}
          {hasSearchResults ? (
            <section className="flight-app-container px-sm-3 p-1 pb-3">
              <Row className="spacing-16">
                <Col
                  lg={3}
                  className=" display-md-none p-0 "
                  style={{ top: `${flightModifyDivHeight + 70}px` }}
                >
                  <OneWayFilters
                    minPrice={minFlightFare}
                    maxPrice={maxFlightFare}
                    carriers={flightCarriesRef.current}
                    selectedFilters={selectedFilters}
                    fareTypes={flightFaresRef.current}
                    onApplyFilter={handleApplyFilter}
                    onTimeFormatChange={handleTimeFormatChange}
                    conversionRate={conversionRate}
                    currencyOption={currencyOption}
                    isAmPmFormat={isAmPmFormatSelected}
                  />
                </Col>
                <Col lg={9} className="margin-for-hotel-results-card">
                  <div
                    style={{
                      backgroundColor: '#f2f2f2',
                    }}
                    className="hide-in-mobile"
                  >
                    <div className="fs-5 fw-500 hide-in-mobile">
                      <div className="d-flex justify-content-between align-items-center">
                        <span>
                          Flights From{' '}
                          {searchRequest.originLocation.split(',')[0]} to{' '}
                          {searchRequest.destinationLocation.split(',')[0]},{' '}
                          {formatDate(
                            getNewDate(searchRequest.onwarddate),
                            DATE_MONTH_YEAR_VIEW_FORMAT,
                          )}
                        </span>
                        <div>
                          <AppIconButton
                            variant="transparent"
                            className="fs-14"
                            onClick={handleopenWhatsappModal}
                          >
                            <MdOutlineWhatsapp title="WhatsApp" />
                          </AppIconButton>
                          <AppIconButton
                            variant="transparent"
                            className="fs-14"
                            onClick={handleOpenEmailModal}
                          >
                            <MdOutlineMail title="Email" />
                          </AppIconButton>
                          <AppIconButton
                            variant="transparent"
                            className="fs-14"
                            onClick={() => setShowInvoiceFare((prev) => !prev)}
                          >
                            {showInvoiceFare ? (
                              <IoMdEyeOff title="Net Fare" />
                            ) : (
                              <IoMdEye title="Net Fare" />
                            )}
                          </AppIconButton>
                        </div>
                      </div>
                    </div>
                    <div className="my-1 hide-in-mobile">
                      <div className="flight-sort-options d-flex">
                        <div
                          className={`sort-btn ${
                            sortParamRef.current === 'price'
                              ? 'selected-sort-btn'
                              : ''
                          }`}
                          onClick={() => handleSort('price', 'asc')}
                        >
                          Cheapest Flights
                        </div>
                        <div
                          className={`sort-btn border-inline ${
                            sortParamRef.current === 'duration'
                              ? 'selected-sort-btn'
                              : ''
                          }`}
                          onClick={() => handleSort('duration', 'asc')}
                        >
                          Shortest Duration
                        </div>
                        <div
                          className={`sort-btn ${
                            sortParamRef.current === 'departure'
                              ? 'selected-sort-btn'
                              : ''
                          }`}
                          onClick={() => handleSort('departure', 'asc')}
                        >
                          Early Depart
                        </div>
                      </div>
                    </div>
                  </div>
                  {isMobileWidth() && (
                    <SortOptions
                      onSort={handleSort}
                      isOnward
                      prevSortParam={sortParamRef.current}
                      isOneWay
                    />
                  )}
                  <div className="my-2 spacing-0 flight-datedict">
                    {dateDict.map((newDate) => (
                      <div
                        key={newDate}
                        className={`col search-by-date-btn  ${
                          newDate === 7 ? 'last-date' : ''
                        } ${isSelectedDate(newDate) ? 'today-date-btn' : ''}`}
                        onClick={() =>
                          handleSearchByDate(
                            add(getNewDate(searchRequest.onwarddate), {
                              days: newDate,
                            }),
                          )
                        }
                      >
                        {newDate > 0 ? (
                          <span>
                            {formatDate(
                              add(getNewDate(searchRequest.onwarddate), {
                                days: newDate,
                              }),
                              DATE_MONTH_DAY_FORMAT,
                            )}
                          </span>
                        ) : (
                          <span>
                            {formatDate(
                              add(getNewDate(searchRequest.onwarddate), {
                                days: newDate,
                              }),
                              DATE_MONTH_DAY_FORMAT,
                            )}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                  {shownResults.map((row, index) => (
                    <OneWayResultCard
                      name="one_way_card"
                      // domint="domestic"
                      domint={
                        isInternationalSearch ? 'international' : 'domestic'
                      }
                      key={row.recommendedflight[0].nextraflightkey}
                      flight={row.recommendedflight[0]}
                      selectedFare={selectedFareRef.current}
                      onFareSelection={handleFareSelection}
                      journeyType={searchRequest.journeytype}
                      searchRequest={searchRequest}
                      onSelectForEmail={handleFlightSelectionForEmail}
                      flightsForEmail={selectedForEmail}
                      showInvoiceFare={showInvoiceFare}
                      index={index}
                      isAmPmFormat={isAmPmFormatSelected}
                      isOnward
                      conversionRate={conversionRate}
                      currencyOption={currencyOption}
                      onNavigateToBookingPage={
                        handleDirectNavigateToBookingPage
                      }
                      onShareViaEmail={handleOpenEmailModal}
                      fareInclusions={fareInclusionRef.current}
                      onShareViaWhatsapp={handleopenWhatsappModal}
                      onMoreFaresUpdate={handleUpdateMoreFares}
                    />
                  ))}
                  {searchResults.length === 0 && progressWidth === 100 && (
                    <NoSearchResults
                      message={formattedMessage('no_search_results_message_1')}
                    />
                  )}
                </Col>
              </Row>
            </section>
          ) : (
            allSearchResultsRef.current.length === 0 &&
            progressWidth === 100 && (
              <NoSearchResults
                message={formattedMessage('no_search_results_message')}
              />
            )
          )}
        </>
      )}
      {openFilters && (
        <AppSidebar
          sidebarTitle={formattedMessage('filters')}
          showActions
          onHideSidebar={() => setOpenFilters(false)}
          className="one-way-filters-modal position-relative p-0"
        >
          <OneWayFilters
            minPrice={minFlightFare}
            maxPrice={maxFlightFare}
            carriers={flightCarriesRef.current}
            selectedFilters={selectedFilters}
            fareTypes={flightFaresRef.current}
            onApplyFilter={handleApplyFilter}
            onTimeFormatChange={handleTimeFormatChange}
            conversionRate={conversionRate}
            currencyOption={currencyOption}
            isAmPmFormat={isAmPmFormatSelected}
          />
        </AppSidebar>
      )}
      {showPriceChangedModal && (
        <AppModal
          modalTitle="Fare Change Alert"
          showCloseButton={false}
          okText="Continue"
          cancelText="Select Another Flight"
          showFooter
          onModalClose={handlePriceChangedModalClose}
        >
          <div className="d-flex flex-column align-items-center red-color fs-3">
            <BsGraphUpArrow />
            <span>Ooops!</span>
          </div>
          <p className="fs-14 mb-0 text-center mt-2">
            The Airline has increased the fare on this route by{' '}
            {formatCurrency(newRepricedAmount - oldAmount)}
          </p>
          <p className="fs-14 mb-0 text-center">
            Please note that airfares e dynamicnd subject to change.
          </p>
          <p className="fs-14 mb-0 text-center">
            Select from the options below
          </p>
          <div className="d-flex flex-column align-items-center fw-600 fs-14 mt-3">
            <span>
              UPDATED FARE{'      '} {formatCurrency(newRepricedAmount)}
            </span>
            <span>
              ORIGINAL FARE{'      '} {formatCurrency(oldAmount)}
            </span>
            <span>
              DIFFERENCE FARE{'      '}{' '}
              {formatCurrency(newRepricedAmount - oldAmount)}
            </span>
          </div>
        </AppModal>
      )}
      {showRefineResult && (
        <AppModal
          modalTitle={formattedMessage('Refine_results')}
          showCloseButton
          onModalClose={() => setShowRefineResult(false)}
        >
          <RefineResults handleClose={() => setShowRefineResult(false)} />
        </AppModal>
      )}
      {openEmailModal && (
        <AppModal
          modalTitle={formattedMessage('send_email_btn')}
          showCloseButton
          size="lg"
          onModalClose={() => setOpenEmailModal(false)}
        >
          <EmailContent
            selectedFlights={selectedForEmail}
            searchRequest={searchRequest}
            onSend={handleSendEmailMessage}
          />
        </AppModal>
      )}
      {openWhatsappModal && (
        <AppModal
          modalTitle="Send Whatsapp"
          showCloseButton
          size="lg"
          onModalClose={() => setOpenWhatsappModal(false)}
        >
          <OneWayWhatsAppModal
            searchRequest={searchRequest}
            selectedForEmail={selectedForEmail}
            onSend={handleSendWhatsappMessage}
          />
        </AppModal>
      )}
      {OpenAlerDialog && (
        <AppModal
          modalTitle="Are You Sure?"
          showCloseButton
          className="help-support-modal"
          cancelText="Close"
          onModalClose={() => setOpenAlerDialog(false)}
        >
          <div className="fs-16 align-items-center p-4">
            {alertMessageRef.current}
          </div>
          <div className="d-flex justify-content-end gap-3 p-2">
            <AppButton
              btnText="NO, Cancel"
              variant="outlined"
              onClick={() => setOpenAlerDialog(false)}
            />
            <AppButton btnText="Yes, Continue" onClick={continueBooking} />
          </div>
        </AppModal>
      )}
    </section>
  );
}

export default FlightOneWaySearchResultsPage;
